import React, { Component } from "react";
import { Row, Col, Space, Image } from "antd";
import { Link } from "react-router-dom";
import "../../App.css";

export default class Faceless extends Component {
  render() {
    const arr = [];
    for (let i = 0; i < 6; i++) {
      arr[i] = i;
    }
    return (
      <>
        <Row>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
          <Col xs={24} sm={22} md={22} lg={20} xl={20}>
            <Row justify="center">
              <Col span={24} className="paddLR10">
                <Link className="breadCrumbText link" to="/home">
                  Home
                </Link>
                &nbsp;&gt;&nbsp;
                <Link className="breadCrumbText link" to="/visdev">
                  VisDev Projects
                </Link>
              </Col>
              <Col span={24} className="visdevTitle">
                Faceless Maiden
              </Col>
              <Col span={24} className="paddTop40"></Col>
            </Row>
          </Col>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
        </Row>
        <Row justify="center">
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
          <Col xs={24} sm={22} md={22} lg={20} xl={20}>
            <Row>
              <Col span={24} className="paddTop40 paddLR10">
                <Space size="large" direction="vertical">
                  {arr.map((item) => {
                    return (
                      <Image
                        alt={`Faceless ${item} Image`}
                        src={`${process.env.PUBLIC_URL}/images/jpg/Faceless_${item}.jpg`}
                        className="img100"
                        loading="lazy"
                        preview={false}
                        placeholder={
                          <Image
                            src={`${process.env.PUBLIC_URL}/images/jpg/Faceless_${item}_blur.jpg`}
                            className="img100"
                            preview={false}
                          />
                        }
                      />
                    );
                  })}
                </Space>
              </Col>
              <Col span={24} className="paddTop40"></Col>
            </Row>
          </Col>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
        </Row>
        <Row>
          <Col span={24}>
            <div className="rH100"></div>
          </Col>
        </Row>
      </>
    );
  }
}
